import {Injectable} from 'ng-metadata/core';


@Injectable()
export class BannerCardContentService {

    constructor() {

    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/resourceRecommender/bannerCardContent.service.ts